<template>
  <Button
    ref="btnRef"
    :class="[
      bem.b(),
      useCustomStyle ? bem.is('btn-custom') : '',
      isBlock ? bem.is('block') : '',
    ]"
    v-bind="getBindValue"
    :type="useCustomStyle ? 'primary' : type"
    :disabled="disabled"
    :style="{ gap: `${props.iconSpace}px`, ...customStyle }"
    @mouseenter="handleHover(true)"
    @mouseleave="handleHover(false)"
  >
    <template v-if="props.icon.iconName || $slots.icon" #icon>
      <slot v-if="$slots.icon" name="icon"></slot>
      <ll-icon
        v-else
        :style="{ order: iconDirection === 'left' ? 0 : 1 }"
        :icon-name="icon.iconName"
        :color="icon.color"
        :size="icon.size"
      />
    </template>
    <slot>
      <template v-if="label">
        <span>{{ label }}</span>
      </template>
    </slot>
  </Button>
</template>

<script setup lang="ts">
import { computed, ref, useAttrs } from 'vue'

import { Button } from 'ant-design-vue'

import { LlIcon } from '@ll-plus/components'

import { createNamespace } from '@ll-plus/utils'

import { omit } from 'lodash-es'
import { buttonProps } from './button'

defineOptions({ name: 'LlButton' })

const props = defineProps(buttonProps)
const emits = defineEmits(['mouseenter', 'mouseleave'])
const bem = createNamespace('button')

const attrs = useAttrs()
const btnRef = ref()

const isHovered = ref(false)

const getBindValue = computed(() => {
  return omit({ ...attrs }, ['class'])
})

// 模拟悬浮效果
const handleHover = (v: boolean) => {
  emits(v ? 'mouseenter' : 'mouseleave')
  if (props.useCustomStyle) {
    isHovered.value = v
  }
}
console.log('测试发布')
const customStyle = computed(() => {
  // 未开启自定义样式
  if (!props.useCustomStyle) return {}

  const baseStyle = {
    border: `1px solid var(--btn-gray-bg)`,
    'box-shadow': `0 2px 0 rgba(0, 0, 0, 0.02)`,
  }

  // 禁用状态样式（最高优先级）
  if (props.disabled) {
    return {
      color: '#c9cdd4',
      'border-color': 'var(--color-border)',
      'background-color': 'rgba(0, 0, 0, 0.04)',
      'box-shadow': 'none',
    }
  }

  // 悬浮
  else if (isHovered.value) {
    return {
      ...baseStyle,
      'background-color': props.hoverBgColor || `var(--btn-gray-bg-hover)`,
      color: props.hoverColor || `var(--color-text)`,
    }
  }
  // 默认
  else {
    return {
      ...baseStyle,
      'background-color': props.bgColor || `var(--btn-gray-bg)`,
      color: props.color || `var(--color-text)`,
    }
  }
})

const blur = () => {
  btnRef.value.blur()
}

defineExpose({ blur })
</script>
